import { ChangeDetectorRef, Directive, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({})
export abstract class BaseComponentDirective implements OnDestroy {
  protected subscriptionCollection: Subscription[];
  protected cdr = inject(ChangeDetectorRef);

  protected constructor() {

    this.subscriptionCollection = [];
  }

  protected set subSink(value: Subscription) {
    this.subscriptionCollection.push(value);
  }

  ngOnDestroy(): void {

    if (Array.isArray(this.subscriptionCollection) && this.subscriptionCollection?.length > 0) {

      this.subscriptionCollection.forEach((subscription$) => subscription$.unsubscribe());
    }
  }
}
